import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { BrowserCompatibilityCheck } from './components/BrowserCompatibilityCheck';
import { analyticsService } from './services/analyticsService';
import { useThemeStore } from './stores/themeStore';
import '@fontsource-variable/space-grotesk';
import './index.css';

// Initialize PostHog analytics with session recording
analyticsService.initialize();

// Initialize theme from localStorage (prevents flash of unstyled content)
useThemeStore.getState().initializeTheme();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserCompatibilityCheck>
      <App />
    </BrowserCompatibilityCheck>
  </StrictMode>
);
